import { render, staticRenderFns } from "./section-out.vue?vue&type=template&id=654b27ea&"
import script from "./section-out.vue?vue&type=script&lang=js&"
export * from "./section-out.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports